<style scoped lang="scss">
.sds-notif{
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin-bottom: 15px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 1.2;

  &.warning{
    background:#fffde7;
    border: 1px solid #eebe2e !important;
  }
  &.success{
    background:#e7fffe;
    border: 1px solid #00a191 !important;
  }
}
#create-ms-ind{
  font-family: 'Manrope';
  background: #f9f9f9;
  min-height: calc(100vh - 45px);
}

.questionnaire{
  min-height: 67vh;
  display: flex;
  flex-direction: column;
  border:1px solid #b8b8b8;
  position: relative;
  background:white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  &-navigation{
    display: flex;
    border-bottom:none;
    border-top:1px solid #e0e0e0;
    // border-bottom:1px solid #e0e0e0;
    background: white;
    padding: 0px 50px 0px 50px;

    & .item{

      font-size: 13px;
      font-weight: 500;
      padding: 5px 15px;
      // margin:-1px;
      border-left:1px solid #e0e0e0;
      &:last-child{
        border-right:1px solid #e0e0e0;
      }
      &.active{
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #005f4f;
        border:1px solid #005f4f;
      }
      &.invalid{
        // color: #2d2d2d;
        color: white;
        font-size: 13px;
        // background: #e5e5e5;
        background: #dc3545;
        border-color: rgb(255, 214, 214);
      }
      &.status{
        font-weight: 600;
        background: white;
        margin-left: auto;
        border:none;
        font-size: 12px;
        padding-right:0 ;
        & div{
          border-radius:5px ;
          padding: 1px 3px;
        }
        & .draft{
          background-color: #cccccc;
          color: #424242;
          border: 1px solid #cccccc;
        }
        
        & .submitted{
          color: #1976D2;
          background: #E3F2FD;
          border: 1px solid #90CAF9;
          
          &.darker{
            background: #006aff;
            color: white;
          }
        }
        & .under-review{
          color: #7b6400;
          background: #ffe600;
          border: 1px solid #d8c300;
        }
        & .correction-required, &.revised{
          color: #7B1FA2;
          background: #F3E5F5;
          border: 1px solid #CE93D8;
          
        }
        & .rejected{
          background: rgb(253, 208, 208);
          color: rgb(201, 0, 0);
          border: 1px solid rgb(255, 143, 143);
        }
        & .approved{
          font-weight: 600;
          background: #c4ffc4;
          color: rgb(22, 139, 22);
          border: 1px solid rgb(97, 213, 97);
        }
        & .published{
          font-weight: 500;
          background: rgb(192, 255, 192);
          color: rgb(25, 136, 25);
          border: 1px solid rgb(154, 234, 154);
        }

      }
      
    }
    

    & .button-navigation{
      & .prev{
        padding: 5px 15px;
      }
      & .next{
        padding: 5px 15px;
        background: teal;
        color: white;
      }
      
    }
  }
  &.entry-mode{
    & .blok-detail {
      padding: 20px 25px;

      & .question{
        border:none !important;
      }
      
    }
  }
  & .blok{
    & .blok-title {
      color: #2d2d2d;
      font-size: 14px;
      font-weight: 700;
      background: #e5e5e5;
      padding: 0.25rem 0.5rem;
      text-align: center;

      border-top:1px solid #b8b8b8;
      border-bottom:1px solid #b8b8b8;
      text-transform: uppercase;
    }
    &:first-child .blok-title{
      border-top: none;
    }
  }
  & .blok-detail {
    padding: 20px 25px;

    & .question{
      padding: 10px 0px;
      &:first-child{
        padding-top: 0;
      }
      &:last-child{
        padding-bottom: 0;
      }
      &:not(:last-child){
        border-bottom: 1px solid rgb(210, 210, 210);
      }
      &__name{
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 0rem;
        color: #212121;
      }
      &__value{
        font-size: 13px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #525252;

        & input, & .vue-treeselect, & textarea, & div[role="radiogroup"], & ul, & .multiselect{
          margin-top: 3px !important;
        }
        & div[role="radiogroup"]{
          margin-left: 3px !important;
        }
        & .custom-checkbox{
          margin-left: 3px !important;
        }
        & ul{
          margin-left: -35px !important;
        }
      }
      &__info{
        font-size: 12px;
        font-weight: 500;
        margin-bottom: 0rem;
        color: #414141;
      }
      & ul.list{
        list-style-type: none;
        margin-left: -40px;
        margin-bottom: 0;

        & li::before{
          content: '- ';
        }
        & li:only-child::before{
          content: '';
        }
      }
    }

    &  p.question {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 0rem;
      color: #212121;
    }
    &  p {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 0rem;
      color: #525252;
    }
    
  }
  &__status{
		margin-top: -7px;
    margin-left: 4px;
		padding:3px 5px;
    letter-spacing: .3px;
    font-size: 12px;
		border-radius: 5px 0px 5px 0px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 600;
		color: rgb(251, 229, 229);
		border: 1px solid #cccccc;
		background-color: #cccccc;
		color: #424242;

    &2{
      border-radius: 0px 0px 0px 15px;
      position: absolute;
      top:-1px;
      right:-1px;
      padding:5px 10px;
    }
    &3{
      margin-top: 0px;
      margin-left: 0px;
      font-weight: 600;
      padding:3px 5px;
    }
		&.draft, &2.draft , &3.draft{
      color: #424242;
      background: #cccccc;
      border: 1px solid #bbbbbb;
    }
		&.submitted, &2.submitted, &3.submitted{
      color: #1976D2;
      background: #E3F2FD;
      border: 1px solid #90CAF9;
      
      &.darker{
        background: #006aff;
        color: white;
      }
    }
    &.under-review, &2.under-review, &3.under-review{
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border: 1px solid #dfcd2b;
    }
    &.correction-required, &.revised, &2.correction-required, &2.revised, &3.correction-required, &3.revised{
      color: #7B1FA2;
      background: #F3E5F5;
      border: 1px solid #CE93D8;
      
    }
    &.rejected, &2.rejected, &3.rejected{
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border: 1px solid rgb(255, 143, 143);
    }
    &.approved, &2.approved, &3.approved{
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border: 1px solid rgb(97, 213, 97);
    }
    &.published, &2.published, &3.published{
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border: 1px solid rgb(154, 234, 154);
    }

	}
  &__body{
    flex-direction: column;
    display: flex;
    flex-grow: 1;
  }
  &__footer{
    border-top:1px solid #b8b8b8;
    bottom:0;
    display: flex;
    padding: 10px 20px;
  }
  
}


/* ============================================================
   History Status (ms_keg_histories)
   ============================================================ */
.history-status {
  margin-top: 12px;

  &__item {
    padding: 8px 10px;
    margin-bottom: 8px;
    border-left: 3px solid #e0e0e0;
    background: #fafafa;
    border-radius: 4px;
  }

  &__number {
    font-size: 11px;
    font-weight: 600;
    color: #424242;
    min-width: 18px;
  }

  &__badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .3px;
    border: 1px solid transparent;

    &--draft {
      color: #424242;
      background: #cccccc;
      border-color: #bbbbbb;
    }
    &--submitted {
      color: #1976D2;
      background: #E3F2FD;
      border-color: #90CAF9;
    }
    &--under-review {
      font-weight: 600;
      color: #8c7200;
      background: #fff27d;
      border-color: #dfcd2b;
    }
    &--correction-required,
    &--revised {
      color: #7B1FA2;
      background: #F3E5F5;
      border-color: #CE93D8;
    }
    &--rejected {
      background: rgb(253, 208, 208);
      color: rgb(201, 0, 0);
      border-color: rgb(255, 143, 143);
    }
    &--approved {
      font-weight: 600;
      background: #c4ffc4;
      color: rgb(22, 139, 22);
      border-color: rgb(97, 213, 97);
    }
    &--published {
      font-weight: 500;
      background: rgb(192, 255, 192);
      color: rgb(25, 136, 25);
      border-color: rgb(154, 234, 154);
    }
  }

  &__info {
    font-size: 10px;
    color: #757575;
    margin-top: 4px;
    margin-left: 18px;
    font-style: italic;
  }

  &__rejection {
    font-size: 11px;
    color: #c9302c;
    margin-top: 4px;
    margin-left: 18px;
    padding: 4px 6px;
    background: #fff5f5;
    border-radius: 3px;
    border: 1px solid #f5c6cb;
  }
}
</style>
<template>
  <div id="create-ms-ind">
    <div class="page-control--secondary" >
      <div class="page-control__body">
        <div class="page-control__left">
          <button class="button button--text button--action mr-2"  id="backUsulanList" @click="$router.back()">
              <VueFeather type="arrow-left" size="18" stroke-width="1.5" style="display:block"></VueFeather>
          </button>
          <b-popover target="backUsulanList" triggers="hover" placement="bottom">
            <template #title>Kembali ke halaman daftar usulan</template>
            Pastikan anda sudah menyimpan isian terlebih dahulu dengan klik tombol draft atau submit, karena ketika kembali isian ada akan hilang
          </b-popover>
          <div class="my-1">
            <div class="d-flex align-items-start" style="font-family:'Manrope';font-weight:600;font-size:16px;color:#032F05;line-height:1">
              <div v-if="route  == 'AddMsInd'">
                Lapor<span class="text-primary" > Metadata Indikator </span>Baru
              </div>
              <div v-else-if="route  == 'UpdateMsInd'">
                Update Metadata Indikator <span class="text-primary" >{{data.nama}}</span> 
              </div>
              <div v-else>
                Detail Metadata Indikator <span class="text-primary" >{{data.nama}}</span> 
              </div>
            </div>
            <div class="" style="font-family:'Manrope';font-weight:500;font-size:12px;color:#515151;">
              Harap baca panduan terlebih dahulu, agar pelaporan Anda dapat menjadi lebih mudah.
            </div>
            
          </div>
        </div>
        <div class="page-control__center">
        </div>
        <div class="page-control__right align-items-center">
          <div v-if="route != 'ViewMsInd' && route != 'ApproveMsInd'" class="d-flex align-items-center" style="margin:5px 0px 5px 5px">
            <button 
              v-if="route == 'UpdateMsInd'"
              class="button mr-2" 
              :variant="isReviewOpen ? 'primary' : 'outlined'" 
              size="sm" 
              @click="isReviewOpen = !isReviewOpen"
              title="Tampilkan / Sembunyikan Panel Catatan & Histori"
            >
              <VueFeather type="mail" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Catatan Pemeriksaan
              <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
              </span>
            </button>
            <div class="tags">
            <div :class="'mr-1 tag tag--status '+statusFormatterStyle(form.status)">
              <div class="tag__field">Status</div>
              <div class="tag__value">{{statusFormatter(form.status)}}</div>
            </div>
          </div>
          
          <div class="w-5" style="border-right:1px solid #e4e4e4; height:35px;"></div>
            <button  class="button mx-2" variant="outlined" size="sm" @click="save('DRAFT')">
              <VueFeather type="check" size="15" stroke-width="2.5" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan Sementara
            </button>
            <button  class="button" variant="primary" size="sm" @click="save('SUBMITTED')">
              <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Submit
            </button>
          </div>

          <div v-if="route == 'ApproveMsInd'" class="page-control__right align-items-center">
            <button class="button" variant="primary" size="sm" @click="()=>{$bvModal.show('modal-approval')}">
              <VueFeather type="send" size="14" stroke-width="2" style="display:block;"></VueFeather>&nbsp;&nbsp;Simpan
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="content content--borderless">
      <div v-if="isLoading" class="content__loading">
        <img src="@/assets/icons/loading-plane.gif" width="200" height="200" style="margin-top:-60px"/>
        <div style="margin-top:-60px">
          Sedang mengambil data ke server, harap tunggu sebentar....
        </div> 
      </div>
      <div v-else class="content__body" style="margin: 20px 45px 25px 45px">
        
        <div class="tags tags--secondary" style="margin-top:-10px; padding-bottom:10px" v-if="msInd">
          <div class="tag tag--secondary "> 
            <div class="tag__field">ID</div>
            <div class="tag__value">{{msInd.id}}</div>
          </div>
          <div class="tag tag--primary">
            <div class="tag__field">Pelapor</div>
            <div class="tag__value">{{msInd.requester_details ? msInd.requester_details.name : msInd.requested_by}}</div>
          </div>
          <div class="tag tag--secondary "> 
            <div class="tag__field">Tanggal Usulan</div>
            <div class="tag__value">{{msInd.created_at | formatDate}}</div>
          </div>
        </div>

        <!-- <div class="sds-notif warning" v-if="showSdsRedirectNotif == true">
          <div class="mr-3" style="">
            <VueFeather type="alert-triangle" size="26" stroke="#ce9b00" fill="#FFF59D" stroke-width="2" style="display:block;"></VueFeather>
          </div>
          <div >
            <div class="text-13 text-semi-bold " style="color:#ad8200;margin-bottom:2px">Indikator tidak Standar</div>
            <div style="color:#c29200">Indikator yang dipilih sebaiknya merujuk pada Standar Data Statistik (SDS).
              Silahkan usulkan indikator menjadi SDS baru dengan melakukan klik pada tombol disamping ini
              
            </div>
          </div>
          <b-button class="ml-auto button--warning w-101" to="/old-sds/daftar-usulan">Usul SDS</b-button>
        </div>
        <div class="sds-notif success" v-if="showSdsRedirectNotif == false || this.data.id_sds">
          <div class="mr-3" style="">
            <VueFeather type="check-circle" size="26" stroke="#00897B" fill="#c6fffd" stroke-width="2" style="display:block;"></VueFeather>
          </div>
          <div >
            <div class="text-13 text-semi-bold " style="color:#00897B;margin-bottom:2px">Indikator Standar</div>
            <div style="color:#009688">
              Indikator sudah merujuk pada Standar Data Statistik (SDS). Lanjut Pengisian MS-Ind
            </div>
          </div>
        </div> -->

        <b-row>
          <b-col>
            <div class="questionnaire " :class="route == 'ViewMsInd' || route == 'ApproveMsInd' ? '' : 'entry-mode'">
              <div :class="'questionnaire__status2 '+statusFormatterStyle(form.status)" v-if="!['DRAFT','SUBMITTED'].includes(form.status) ">{{statusFormatter(form.status)}}</div>
              
              <div class="form form--sm questionnaire__body">
                <ValidationObserver ref="blok1Observer">
                  <div class="blok">
                    <div class="blok-detail">
                      
                      <div class="question">
                        <div class="question__name">Nama:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.nama}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Nama Indikator"  v-slot="{errors}">
                            <multiselect 
                              tag-placeholder="Tekan Enter untuk input indikator manual" 
                              placeholder="Pilih indikator dari SDS (disetujui) atau ketik secara manual" 
                              selectLabel="" deselectLabel="" selectedLabel="" openDirection="bottom"
                              label="name"  track-by="id" 
                              v-model="sds" 
                              :options="options.sds" 
                              :taggable="true" 
                              :searchable="true"
                              :multiple="false"
                              :allow-empty="true"
                              :loading="isSdsLoading" 
                              :options-limit="300" :limit="3"
                              @search-change="getSdsList"
                              @open="onSdsOpen"
                              :class="errors[0] ? 'invalid': ( data.nama ? 'valid':'')"
                              @tag="inputIndicatorManual"
                              @input="useIndicatorSds"

                              >
                              <template slot="tag" slot-scope="{props}">{{props.search}}</template>
                              <template slot="noOptions">
                                <div class="d-flex align-items-center py-1">
                                  <VueFeather type="search" size="15" stroke="#008b7e" class="mr-2"></VueFeather>
                                  <span style="color:#008b7e">Ketik nama indikator untuk mencari standar data yang disetujui...</span>
                                </div>
                              </template>
                              <template slot="noResult">
                                <div class="d-flex align-items-center py-1 text-muted">
                                  <VueFeather type="info" size="15" class="mr-2"></VueFeather>
                                  <span>Tidak ditemukan indikator standar data yang disetujui. Tekan Enter untuk input manual.</span>
                                </div>
                              </template>
                              <template slot="option" slot-scope="props">
                                <div class="d-flex align-items-center flex-grow-1">
                                  <div >
                                    <div style="white-space:initial">
                                      {{ props.option.name ? props.option.name :props.search}}
                                    </div>
                                    <div class="mt-2 text-11 text-500" v-if="props.option.name != null">
                                      {{props.option.produsen_data_name}}
                                    </div>
                                  </div>
                                  <div v-if="props.option.name != null" :class="'text-nowrap ml-auto status status--'+statusFormatterStyle(props.option.status)">
                                    {{sdsStatusFormatter(props.option.status)}}
                                  </div>
                                </div>
                              </template>
                            </multiselect>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>

                          
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Definisi Indikator:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.definisi}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Definisi Indikator"  rules="required" v-slot="{errors}">
                            <b-form-textarea 
                              rows="3"
                              v-model="data.definisi" 
                              placeholder="Tuliskan secara jelas Definisi Indikator" 
                              :state="errors[0] ? false: (data.definisi? true : null)"
                            >
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Konsep:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >
                          <div v-for="(item, index) in data.konsep" :key="index" class="d-flex">
                            <div class="w-15" v-if="data.konsep.length>1">{{index+1}}.</div>
                            <div>{{item}}</div>
                          </div>
                          <div v-if="data.konsep.length==0">-</div>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationObserver ref="conceptVariableObserver" v-slot="{ validate }">
                            <div v-for="(item, index) in data.konsep" :key="index" >
                              <ValidationProvider :name="'Konsep ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <div class="d-flex">
                                  <b-form-input 
                                    v-model="data.konsep[index]" 
                                    placeholder="Tuliskan Konsep yang digunakan"
                                    :state="errors[0] ? false: (data.konsep[index] ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-button v-if="data.id_sds == null" class="button button--action button--action--delete2 ml-2" style="margin-top:3px"  @click="data.konsep.splice(index,1)" >
                                    <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                <div class="d-flex mt-2" v-if="index==data.konsep.length-1 && data.id_sds == null">
                                  <div class="flex-grow-1 text-600">
                                    Jika Konsep Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button  class="button button--action button--action--view2 " 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.konsep.push(null);
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                
                              </ValidationProvider>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Interpretasi</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.interpretasi}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name=" Interpretasi"  rules="required" v-slot="{errors}">
                            <b-form-textarea 
                              rows="3"
                              v-model="data.interpretasi" 
                              placeholder="Tuliskan secara jelas Interpretasi Indikator" 
                              :state="errors[0] ? false: (data.interpretasi? true : null)"
                            >
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Metode Perhitungan</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.metode_perhitungan}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Metode Perhitungan"  rules="required" v-slot="{errors}">
                            <b-form-textarea 
                              rows="3"
                              v-model="data.metode_perhitungan" 
                              placeholder="Jelaskan secara jelas metode perhitungan yang digunakan" 
                              :state="errors[0] ? false: (data.metode_perhitungan? true : null)"
                            >
                            </b-form-textarea>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name" style="margin-bottom:3px">Rumus</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >
                        <!-- <div class="question__value" > -->
                          <EquationViewer :value="data.rumus ? data.rumus  : '-'" size="sm"></EquationViewer>
                        </div>
                        <div class="question__value" v-else>
                        <!-- <div class="question__value"> -->
                          <ValidationProvider name="Rumus"  rules="required" v-slot="{errors}">
                            <EquationEditor id="formula"
                               :value.sync="data.rumus" 
                               size="md" :state="errors[0] ? false: (data.rumus? true : null)"
                            ></EquationEditor>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Ukuran:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.ukuran}}</div>
                        <div class="question__value" v-else>
                            <b-form-input 
                              v-model="data.ukuran" 
                              placeholder="Tuliskan Ukuran"
                              :state="data.ukuran ? true : null"
                            >
                            </b-form-input>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Satuan:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.satuan}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Satuan"  :rules="data.id_sds == null && data.ukuran ?  'required' : ''"  v-slot="{errors}">
                            <b-form-input 
                              v-model="data.satuan" 
                              placeholder="Tuliskan Satuan "
                              :state="errors[0] ? false: (data.satuan ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Klasifikasi Penyajian:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >
                          <div v-for="(item, index) in data.variabel_disaggregasi" :key="index" class="d-flex">
                            <div class="w-20" v-if="data.variabel_disaggregasi && data.variabel_disaggregasi.length>1">{{index+1}}.</div>
                            <div>{{item.nama || '-'}}</div>
                          </div>
                          <div v-if="data.variabel_disaggregasi.length==0">-</div>
                        </div>
                        <div class="question__value" v-else>
                          <ValidationObserver ref="disaggregationIndicatorObserver" v-slot="{ validate }">
                            <div v-for="(item, index) in data.variabel_disaggregasi" :key="index" >
                              <ValidationProvider :name="'Klasifikasi Penyajian ke-'+(index+1)"  rules="required" v-slot="{errors}">
                                <div class="d-flex">
                                  <b-form-input 
                                    v-model="data.variabel_disaggregasi[index].nama" 
                                    placeholder="Tuliskan Klasifikasi Penyajiannya"
                                    :state="errors[0] ? false: (data.variabel_disaggregasi[index].nama ? true : null)"
                                  >
                                  </b-form-input>
                                  <b-button  v-if="data.variabel_disaggregasi.length>1" class="button button--action button--action--delete2 ml-2" style="margin-top:3px"  @click="data.variabel_disaggregasi.splice(index,1)" >
                                    <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                <div class="d-flex mt-2" v-if="index==data.variabel_disaggregasi.length-1">
                                  <div class="flex-grow-1 text-600">
                                    Jika Aturan Validasi Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button  class="button button--action button--action--view2 " 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.variabel_disaggregasi.push({nama : null, sumber:'input-manual'});
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                                
                              </ValidationProvider>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>

                      <div class="question">
                        <div class="question__name">Apakah Indikator Komposit?</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.apakah_indikator_komposit ? 'Ya' : 'Tidak'}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Apakah Indikator Komposit"  rules="required" v-slot="{errors}">
                            <b-form-radio-group 
                              v-model="data.apakah_indikator_komposit" 
                              :state="errors[0] ? false: (data.apakah_indikator_komposit ? true : null)"
                              :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))"
                              @input="onKompositInput"
                            >
                            </b-form-radio-group>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          
                        </div>
                      </div>

                      
                      <div class="question border-bottom-0" v-if="data.apakah_indikator_komposit">
                        <div class="question__name">Indikator Pembangun:</div>
                        <div class="question__value">
                          <ValidationObserver ref="indicatorComponentObserver" v-slot="{ validate }">
                            <div class="table-wrapper mt-2">
                              <div v-if="kegiatanIndicators.length > 0 && route != 'ViewMsInd' && route != 'ApproveMsInd'" class="d-flex align-items-center justify-content-between mb-2 px-3 py-2" style="background: linear-gradient(90deg, #eef8f6 0%, #f4fbf9 100%); border: 1px solid #c2ece6; border-radius: 6px;">
                                <div class="d-flex align-items-center">
                                  <VueFeather type="activity" size="15" stroke="#008b7e" class="mr-2 flex-shrink-0"></VueFeather>
                                  <div class="text-12" style="color: #005c54;">
                                    Tersedia <strong>{{ kegiatanIndicators.length }}</strong> metadata indikator dari kegiatan ini. Gunakan tombol <strong>Pilih Indikator</strong> atau ketikkan nama untuk autocomplete.
                                  </div>
                                </div>
                                <span class="badge badge-pill ml-2" style="background-color: #008b7e; color: #ffffff; font-size: 11px; font-weight: 600; padding: 4px 10px;">
                                  {{ kegiatanIndicators.length }} Indikator
                                </span>
                              </div>
                              <div v-else-if="route != 'ViewMsInd' && route != 'ApproveMsInd'" class="d-flex align-items-center justify-content-between mb-2 px-3 py-2" style="background-color: #fff8f5; border: 1px solid #ffd8c2; border-radius: 6px;">
                                <div class="d-flex align-items-center">
                                  <VueFeather type="alert-circle" size="15" stroke="#dd6b20" class="mr-2 flex-shrink-0"></VueFeather>
                                  <div class="text-12" style="color: #9c4221;">
                                    Indikator pada kegiatan ini masih 0 atau 1 (dirinya sendiri), sehingga belum ada indikator yang dapat dipilih sebagai indikator pembangun.
                                  </div>
                                </div>
                                <span class="badge badge-pill ml-2" style="background-color: #dd6b20; color: #ffffff; font-size: 11px; font-weight: 600; padding: 4px 10px;">
                                  0 Indikator
                                </span>
                              </div>
                              <b-table-simple class="table table--light table--bordered">
                                <thead>
                                  <tr>
                                    <th class="w-40">No</th>
                                    <th>Nama Indikator Pembangun</th>
                                    <th>Publikasi Ketersediaan</th>
                                  </tr>
                                </thead>
                                <tbody v-if="route == 'ViewMsInd' || route == 'ApproveMsInd'">
                                  <tr v-for="(item, index) in data.indikator_pembangun" :key="index">
                                    <td class="text-center">
                                      {{index+1}}  
                                    </td>
                                    <td>{{item.nama}}</td>
                                    <td>
                                      <div class="d-flex" v-for="(item2, index2) in item.sumber_publikasi" :key="index2">
                                        <div class="w-51" v-if="item.sumber_publikasi.length>1">{{index2+1}}</div>
                                        <div>{{item2}}</div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr v-for="(item, index) in data.indikator_pembangun" :key="index">
                                    <td class="text-center align-middle">
                                      <b-form-input :value="index+1" disabled style="text-align:center;" class="input-custom-var"></b-form-input> 
                                    </td>
                                    <td class="align-middle">
                                      <div class="d-flex align-items-center">
                                        <div class="mr-2" style="flex:1">
                                          <ValidationProvider :name="'Nama Indikator Pembangun ke-'+(index+1)" rules="required" v-slot="{errors}">
                                            <div class="d-flex align-items-center">
                                              <div class="flex-grow-1 position-relative">
                                                <b-form-input 
                                                  v-model="item.nama" 
                                                  :list="'datalist-ind-' + index"
                                                  placeholder="Tuliskan nama indikator atau pilih..."
                                                  :state="errors[0] ? false: (item.nama ? true : null)"
                                                  class="input-custom-var"
                                                  @change="onIndikatorPembangunChange(item)"
                                                >
                                                </b-form-input>
                                              </div>
                                              <b-dropdown 
                                                v-if="kegiatanIndicators.length > 0"
                                                right 
                                                no-caret
                                                class="dropdown-pilih-var ml-2 flex-shrink-0"
                                                toggle-class="btn-pilih-var"
                                                menu-class="menu-pilih-var shadow"
                                              >
                                                <template #button-content>
                                                  <VueFeather type="activity" size="13" class="btn-var-icon"></VueFeather>
                                                  <span class="btn-var-label">Pilih Indikator</span>
                                                  <VueFeather type="chevron-down" size="12" class="btn-var-chevron"></VueFeather>
                                                </template>
                                                <b-dropdown-header class="px-3 py-2 text-12 font-weight-bold d-flex justify-content-between align-items-center" style="background-color: #f8fafc; border-bottom: 1px solid #edf2f7;">
                                                  <span style="color: #008b7e;">Indikator Kegiatan Ini</span>
                                                  <span class="badge badge-pill" style="background-color: #008b7e; color: #ffffff; font-size: 11px;">{{ kegiatanIndicators.length }}</span>
                                                </b-dropdown-header>
                                                <div style="max-height: 260px; overflow-y: auto; min-width: 320px; padding: 4px 0;">
                                                  <b-dropdown-item 
                                                    v-for="ind in kegiatanIndicators" 
                                                    :key="ind.id" 
                                                    class="var-dropdown-item"
                                                    @click="onSelectIndikatorPembangun(item, ind)"
                                                  >
                                                    <div class="d-flex align-items-start py-1">
                                                      <VueFeather type="corner-down-right" size="13" stroke="#008b7e" class="mr-2 mt-1 flex-shrink-0"></VueFeather>
                                                      <div style="min-width: 0;">
                                                        <div class="text-13 font-weight-bold text-dark text-truncate" :title="ind.nama">
                                                          {{ ind.nama }}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </b-dropdown-item>
                                                </div>
                                              </b-dropdown>
                                              <b-button
                                                v-else
                                                disabled
                                                class="btn-pilih-var ml-2 flex-shrink-0"
                                                style="opacity: 0.55; cursor: not-allowed; border-color: #cbd5e0 !important; color: #718096 !important; background-color: #edf2f7 !important;"
                                                title="Indikator pada kegiatan ini masih 0 atau 1 (dirinya sendiri)"
                                              >
                                                <VueFeather type="activity" size="13" class="btn-var-icon" stroke="#a0aec0"></VueFeather>
                                                <span class="btn-var-label">Pilih Indikator</span>
                                              </b-button>
                                            </div>
                                            <datalist :id="'datalist-ind-' + index">
                                              <option v-for="ind in kegiatanIndicators" :key="ind.id" :value="ind.nama">
                                                {{ ind.nama }}
                                              </option>
                                            </datalist>
                                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                          </ValidationProvider>
                                        </div>
                                        <div v-if="index != 0" class="w-30 flex-shrink-0">
                                          <b-button class="button button--action button--action--delete2" @click="data.indikator_pembangun.splice(index,1)">
                                            <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-center align-middle">
                                      <div v-for="(item2, index2) in item.sumber_publikasi" :key="index2" class="d-flex align-items-center" :class="{ 'mt-2': index2 > 0 }">
                                        <div class="mr-2" style="flex:1">
                                          <ValidationProvider :name="'Publikasi Ketersediaan ke-'+(index2+1)" rules="required" v-slot="{errors}">
                                            <b-form-input 
                                              v-model="item.sumber_publikasi[index2]" 
                                              placeholder="Tuliskan Sumber Publikasi Ketersediaan Indikator Pembangun"
                                              :state="errors[0] ? false: (item.sumber_publikasi[index2] ? true : null)"
                                              class="input-custom-var"
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                          </ValidationProvider>
                                        </div>
                                        <div class="w-30 flex-shrink-0">
                                          <b-button v-if="index2==0" class="button button--action button--action--view2" @click="()=>{
                                            validate().then(result =>{
                                              if(result){
                                                item.sumber_publikasi.push(null);
                                              }
                                            })}"
                                          >
                                            <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                          <b-button v-else class="button button--action button--action--delete2" @click="item.sumber_publikasi.splice(index2,1)">
                                            <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-if="data.indikator_pembangun.length==0">
                                  <tr>
                                    <td :colspan="route == 'ViewMsInd' ? 3 : 4">
                                      <div class="table__empty">
                                        <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                        Indikator Pembangun belum ada yang diinput
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </b-table-simple>
                              <div class="pagination-wrapper d-block" style="padding: 7px 7px" v-if="route != 'ViewMsInd'  && route != 'ApproveMsInd'">
                                <div class="d-flex align-items-center">
                                  <div class="flex-grow-1 text-600 text-13">
                                    Jika Indikator Pembangun Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button class="button button--action button--action--view2" 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.indikator_pembangun.push({
                                            nama: null,
                                            sumber_publikasi: [
                                              null
                                            ],
                                          });
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>
                      <div class="question border-bottom-0" v-if="data.apakah_indikator_komposit==false">
                        <div class="question__name">Variabel Pembangun:</div>
                        <div class="question__value">
                          <ValidationObserver ref="variableComponentObserver" v-slot="{ validate }">
                            <div class="table-wrapper mt-2">
                              <div v-if="kegiatanVariables.length > 0 && route != 'ViewMsInd' && route != 'ApproveMsInd'" class="d-flex align-items-center justify-content-between mb-2 px-3 py-2" style="background: linear-gradient(90deg, #eef8f6 0%, #f4fbf9 100%); border: 1px solid #c2ece6; border-radius: 6px;">
                                <div class="d-flex align-items-center">
                                  <VueFeather type="database" size="15" stroke="#008b7e" class="mr-2 flex-shrink-0"></VueFeather>
                                  <div class="text-12" style="color: #005c54;">
                                    Tersedia <strong>{{ kegiatanVariables.length }}</strong> metadata variabel dari kegiatan ini. Gunakan tombol <strong>Pilih Variabel</strong> atau ketikkan nama untuk autocomplete.
                                  </div>
                                </div>
                                <span class="badge badge-pill ml-2" style="background-color: #008b7e; color: #ffffff; font-size: 11px; font-weight: 600; padding: 4px 10px;">
                                  {{ kegiatanVariables.length }} Variabel
                                </span>
                              </div>
                              <b-table-simple class="table table--light table--bordered">
                                <thead>
                                  <tr>
                                    <th class="w-40">No</th>
                                    <th>Nama Variabel Pembangun</th>
                                    <th>Kegiatan Penghasil Variabel Pembangun</th>
                                  </tr>
                                </thead>
                                <tbody v-if="route == 'ViewMsInd' || route == 'ApproveMsInd'">
                                  <tr v-for="(item, index) in data.variabel_pembangun" :key="index">
                                    <td class="text-center">
                                      {{index+1}}  
                                    </td>
                                    <td>{{item.nama}}</td>
                                    <td>
                                      <div class="d-flex" v-for="(item2, index2) in item.kegiatan_penghasil" :key="index2">
                                        <div class="w-51" v-if="item.kegiatan_penghasil.length>1">{{index2+1}}</div>
                                        <div>{{item2}}</div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-else>
                                  <tr v-for="(item, index) in data.variabel_pembangun" :key="index">
                                    <td class="text-center align-middle">
                                      <b-form-input :value="index+1" disabled style="text-align:center;" class="input-custom-var"></b-form-input> 
                                    </td>
                                    <td class="align-middle">
                                      <div class="d-flex align-items-center">
                                        <div class="mr-2" style="flex:1">
                                          <ValidationProvider :name="'Nama Variabel Pembangun ke-'+(index+1)" rules="required" v-slot="{errors}">
                                            <div class="d-flex align-items-center">
                                              <div class="flex-grow-1 position-relative">
                                                <b-form-input 
                                                  v-model="item.nama" 
                                                  :list="'datalist-var-' + index"
                                                  placeholder="Tuliskan nama variabel atau pilih..."
                                                  :state="errors[0] ? false: (item.nama ? true : null)"
                                                  class="input-custom-var"
                                                  @change="onVariabelPembangunChange(item)"
                                                >
                                                </b-form-input>
                                              </div>
                                              <b-dropdown 
                                                v-if="kegiatanVariables.length > 0"
                                                right 
                                                no-caret
                                                class="dropdown-pilih-var ml-2 flex-shrink-0"
                                                toggle-class="btn-pilih-var"
                                                menu-class="menu-pilih-var shadow"
                                              >
                                                <template #button-content>
                                                  <VueFeather type="database" size="13" class="btn-var-icon"></VueFeather>
                                                  <span class="btn-var-label">Pilih Variabel</span>
                                                  <VueFeather type="chevron-down" size="12" class="btn-var-chevron"></VueFeather>
                                                </template>
                                                <b-dropdown-header class="px-3 py-2 text-12 font-weight-bold d-flex justify-content-between align-items-center" style="background-color: #f8fafc; border-bottom: 1px solid #edf2f7;">
                                                  <span style="color: #008b7e;">Variabel Kegiatan Ini</span>
                                                  <span class="badge badge-pill" style="background-color: #008b7e; color: #ffffff; font-size: 11px;">{{ kegiatanVariables.length }}</span>
                                                </b-dropdown-header>
                                                <div style="max-height: 260px; overflow-y: auto; min-width: 320px; padding: 4px 0;">
                                                  <b-dropdown-item 
                                                    v-for="v in kegiatanVariables" 
                                                    :key="v.id" 
                                                    class="var-dropdown-item"
                                                    @click="onSelectVariabelPembangun(item, v)"
                                                  >
                                                    <div class="d-flex align-items-start py-1">
                                                      <VueFeather type="corner-down-right" size="13" stroke="#008b7e" class="mr-2 mt-1 flex-shrink-0"></VueFeather>
                                                      <div style="min-width: 0;">
                                                        <div class="text-13 font-weight-bold text-dark text-truncate" :title="v.nama">
                                                          {{ v.nama }}
                                                        </div>
                                                        <small v-if="v.alias" class="text-muted d-block text-truncate" :title="v.alias">
                                                          Alias: {{ v.alias }}
                                                        </small>
                                                      </div>
                                                    </div>
                                                  </b-dropdown-item>
                                                </div>
                                              </b-dropdown>
                                            </div>
                                            <datalist :id="'datalist-var-' + index">
                                              <option v-for="v in kegiatanVariables" :key="v.id" :value="v.nama">
                                                {{ v.alias ? `${v.nama} (${v.alias})` : v.nama }}
                                              </option>
                                            </datalist>
                                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                          </ValidationProvider>
                                        </div>
                                        <div v-if="index != 0" class="w-30 flex-shrink-0">
                                          <b-button class="button button--action button--action--delete2" @click="data.variabel_pembangun.splice(index,1)">
                                            <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-center align-middle">
                                      <div v-for="(item2, index2) in item.kegiatan_penghasil" :key="index2" class="d-flex align-items-center" :class="{ 'mt-2': index2 > 0 }">
                                        <div class="mr-2" style="flex:1">
                                          <ValidationProvider :name="'Kegiatan Penghasil ke-'+(index2+1)" rules="required" v-slot="{errors}">
                                            <b-form-input 
                                              v-model="item.kegiatan_penghasil[index2]" 
                                              placeholder="Tuliskan Kegiatan Penghasil Variabel Pembangun"
                                              :state="errors[0] ? false: (item.kegiatan_penghasil[index2] ? true : null)"
                                              class="input-custom-var"
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                                          </ValidationProvider>
                                        </div>
                                        <div class="w-30 flex-shrink-0">
                                          <b-button v-if="index2==0" class="button button--action button--action--view2" @click="()=>{
                                            validate().then(result =>{
                                              if(result){
                                                item.kegiatan_penghasil.push(null);
                                              }
                                            })}"
                                          >
                                            <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                          <b-button v-else class="button button--action button--action--delete2" @click="item.kegiatan_penghasil.splice(index2,1)">
                                            <VueFeather type="x" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                          </b-button>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                                <tbody v-if="data.variabel_pembangun.length==0">
                                  <tr>
                                    <td :colspan="route == 'ViewMsInd' ? 3 : 4">
                                      <div class="table__empty">
                                        <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                                        Indikator Pembangun belum ada yang diinput
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </b-table-simple>
                              <div class="pagination-wrapper d-block" style="padding: 7px 7px" v-if="route != 'ViewMsInd' && route != 'ApproveMsInd'">
                                <div class="d-flex align-items-center">
                                  <div class="flex-grow-1 text-600 text-13">
                                    Jika Variabel Pembangun Lebih dari satu bisa melakukan klik tombol tambah
                                  </div>
                                  <b-button class="button button--action button--action--view2" 
                                    @click="()=>{
                                      validate().then(result =>{
                                        if(result){
                                          data.variabel_pembangun.push({
                                            nama: null,
                                            kegiatan_penghasil: [
                                              null
                                            ],
                                          });
                                        }
                                      })}">
                                    <VueFeather type="plus" size="14" stroke-width="2" style="display:block;"></VueFeather>
                                  </b-button>
                                </div>
                              </div>
                            </div>
                          </ValidationObserver>
                        </div>
                      </div>
                        
                      <div class="question">
                        <div class="question__name">Level Estimasi:</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.level_estimasi || '-'}}</div>
                        <div class="question__value" v-else>
                          <ValidationProvider name="Level Estimasi"  rules="required" v-slot="{errors}">
                            <b-form-input 
                              v-model="data.level_estimasi" 
                              placeholder="Tuliskan level estimasi indikator"
                              :state="errors[0] ? false: (data.level_estimasi ? true : null)"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                          </ValidationProvider>
                          <div class="question__info">
                            Isikan level estimasi atau level terendah dari penyajian indikator yang dihasilkan dari kegiatan statistik terkait. 
                            Level estimasi disajikan pada tingkat nasional, provinsi, kabupaten/kota, kecamatan, desa/kelurahan, rumah tangga, atau individu
                          </div>
                        </div>
                        
                      </div>

                      <div class="question">
                        <div class="question__name">Apakah Indikator Dapat Diakses Umum?</div>
                        <div class="question__value" v-if="route == 'ViewMsInd' || route == 'ApproveMsInd' " >{{data.apakah_indikator_bisa_diakses_umum ? 'Ya': 'Tidak'}}</div>
                        <div class="question__value" v-else>
                        <b-form-radio-group v-model="data.apakah_indikator_bisa_diakses_umum" :options="options.ya_tidak.map(x=>({text:x.label,value:x.id}))"></b-form-radio-group>
                        </div>
                      </div>


                    </div>
                  </div>
                </ValidationObserver>

                

                
              </div>
            </div>
          </b-col>
          <b-col id="review" cols="4" class="pr-0 mr-0" v-if="isReviewVisible">
            <div class="sidebar-cards-wrapper" style="position: sticky; top: 157px; max-height: calc(100vh - 175px); overflow-y: auto; padding-right: 2px;">
              
              <!-- CARD 1: Catatan Pemeriksaan -->
              <div class="review my-0 mx-0 mb-3" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;"> 
                <div class="review__header" style="cursor: pointer;" @click="isReviewCardOpen = !isReviewCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="mail" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Catatan Pemeriksaan
                    <span v-if="(form.reviews && form.reviews.length > 0) || (reviewHistories && reviewHistories.length > 0)" class="badge badge-light ml-1 text-primary">
                      {{ (form.reviews ? form.reviews.length : 0) + (reviewHistories ? reviewHistories.length : 0) }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button mr-1" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isReviewCardOpen = !isReviewCardOpen"
                      :title="isReviewCardOpen ? 'Sembunyikan Catatan Pemeriksaan' : 'Tampilkan Catatan Pemeriksaan'"
                    >
                      <VueFeather :type="isReviewCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                    <button class="button" variant="icon" size="sm" @click.stop="isReviewOpen = false" title="Tutup Panel">
                      <VueFeather type="x" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isReviewCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px;">
                    <div style="margin-bottom:20px;" v-if="form.reviews && form.reviews.length>0" >
                        <div v-for="(reviewItem, reviewIndex) in form.reviews" :key="reviewIndex" class="review-item d-block">
                          <div class="d-flex">
                              <div class="review-item__number">{{reviewIndex+1}}.</div>
                              <div class="review-item__note">
                                <span class="review-item__field" v-if="reviewItem.field">
                                  #{{ reviewItem.field }} : 
                                </span>
                                {{reviewItem.note}}
                              </div>
                          </div>
                          <div class="d-flex align-items-center review-item__info pt-1 mb-1" style="padding-left:19px">
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-if="reviewItem.created_at">{{reviewItem.created_at | formatDate}}</div>
                              <div class="text-10 text-500 mr-2" style="line-height:1" v-else-if="msInd">{{msInd.created_at | formatDate}}</div>
                              <div class="ml-auto" v-if="route == 'UpdateMsInd' || route == 'ApproveMsInd'">
                                <b-button  
                                    class="button button--action button--action--delete" 
                                    style="height:20px;width:20px!important;min-width:20px!important" 
                                    v-b-tooltip.hover title="Hapus Catatan"
                                    @click="form.reviews.splice(reviewIndex, 1)"
                                >
                                    <VueFeather type="x" size="12"></VueFeather>
                                </b-button>
                              </div>
                          </div>
                        </div>
                    </div>
                    <div class="history-review" v-if="msInd" >
                        <div class="text-bold text-primary" style="margin:5px 11px">History Pemeriksaan:</div>
                        <div v-if="reviewHistories && reviewHistories.length==0" class="" style="margin-top:-5px;margin-left:11px"> Belum ada history yang tersedia</div>
                        <div v-else class="mt-1">
                          <div v-for="(reviewItem, reviewIndex) in reviewHistories" :key="reviewIndex" class="review-item d-block">
                              <div class="d-flex">
                                  <div class="review-item__number">{{reviewIndex+1}}.</div>
                                  <div class="review-item__note">
                                    <span class="review-item__field" v-if="reviewItem.field">
                                      #{{ reviewItem.field }} : 
                                    </span>
                                    {{reviewItem.note}}
                                  </div>
                              </div>
                              <div class="d-flex align-items-center review-item__info pt-1" style="padding-left:19px" v-if="reviewItem.created_at">
                                  <div class="text-10 text-500 mr-2" style="line-height:1">{{reviewItem.created_at | formatDate}}</div>
                              </div>
                          </div>
                        </div>
                    </div>
                  </div>

                  <div class="review__footer form form--sm mt-auto" v-if="route == 'UpdateMsInd' || route == 'ApproveMsInd'">
                    <Treeselect  
                      placeholder="Pilih attribute yang diberikan catatan"
                      v-model="review.field" 
                      :options="Object.keys(data).filter(x=>x!='id_sds').map(x=>({id:x.replace('_','-'), label: capitalize(x.replace('_',' '))}))" 
                      :disable-branch-nodes="true" 
                      :clearable="true" 
                      class="small-container"
                      :loadOptions="loadOptions">
                    </Treeselect>
                    <b-form-textarea 
                      class="mt-1 text-13"
                      rows="3"
                      v-model="review.note" 
                      placeholder="Tuliskan catatan pemeriksaan..." 
                    >
                    </b-form-textarea>
                    <div class="d-flex justify-content-end mt-2">
                      <button 
                        class="button" 
                        variant="primary" 
                        size="sm" 
                        :disabled="!review.note || !review.note.trim()"
                        @click="()=>{
                          form.reviews.push({
                            field: review.field,
                            note: review.note.trim(),
                            created_at: now,
                          });
                          review = { field: null, note: null };
                        }"
                      >
                        <VueFeather type="plus" size="14" stroke-width="2"></VueFeather>&nbsp; Tambah Catatan
                      </button>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <!-- CARD 2: Histori Status -->
              <div class="review my-0 mx-0" style="position: relative; top: 0; height: auto; min-height: unset; margin: 0 0 16px 0 !important;" v-if="msInd && msIndHistories && msIndHistories.length>0">
                <div class="review__header" style="cursor: pointer;" @click="isHistoryStatusCardOpen = !isHistoryStatusCardOpen">
                  <div class="review__header__icon"> 
                    <VueFeather type="clock" size="16" stroke-width="2" style="display:block"></VueFeather>
                  </div>
                  <div class="review__header__title">
                    Histori Status
                    <span class="badge badge-light ml-1 text-primary">
                      {{ msIndHistories.length }}
                    </span>
                  </div>
                  <div class="review__header__close ml-auto d-flex align-items-center">
                    <button 
                      class="button" 
                      variant="icon" 
                      size="sm" 
                      @click.stop="isHistoryStatusCardOpen = !isHistoryStatusCardOpen"
                      :title="isHistoryStatusCardOpen ? 'Sembunyikan Histori Status' : 'Tampilkan Histori Status'"
                    >
                      <VueFeather :type="isHistoryStatusCardOpen ? 'chevron-up' : 'chevron-down'" size="16" stroke-width="2" style="display:block"></VueFeather>
                    </button>
                  </div>
                </div>

                <b-collapse v-model="isHistoryStatusCardOpen">
                  <div class="review__body" style="overflow-y:auto; max-height: 380px; padding: 10px 12px;">
                    <div class="history-status mt-0" style="margin: 0px 0px;">
                      <div v-for="(history, historyIndex) in msIndHistories" :key="historyIndex" class="history-status__item">
                          <div class="d-flex align-items-center">
                              <div class="history-status__number">{{historyIndex+1}}.</div>
                              <div :class="'history-status__badge history-status__badge--'+ statusFormatterStyle(history.status)">
                                  {{statusFormatter(history.status)}}
                              </div>
                              <div class="text-10 text-500 ml-auto" v-if="history.created_at" style="line-height:1">
                                  {{history.created_at | formatDate}}
                              </div>
                          </div>
                          <div class="history-status__info" v-if="history.created_by && history.created_by.organization && history.created_by.organization.name">
                              <span>{{history.created_by.organization.name}}</span>
                          </div>
                          <div class="history-status__rejection" v-if="history.status == 'REJECTED' && history.rejection_note">
                              <strong>Catatan Penolakan:</strong> {{history.rejection_note}}
                          </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>

            </div>
          </b-col>
        </b-row>
        
      </div>
      
    </div>
    <b-modal hide-header hide-footer id="modal-error" size="sm" content-class="modal--error text-center mt-5" dialog-class="d-flex justify-content-center">
      <div>
        <div class="text-center py-5 px-2" style="color:red">
          <div class="mb-3 d-flex justify-content-center align-item-center">
            <div class="border mx-4 " style="border-color:#F48FB1 !important;width:40%">
              <div style="position:relative;background-color:#FCE4EC;height:20px;border-color:#F48FB1 !important" class="border-bottom mb-2" >
                <div style="position:absolute;top:-10px;right:-10px"><VueFeather type="x-circle" size="20" stroke-width="1.5" fill="#FCE4EC"></VueFeather></div>
              </div>
              <div class="px-3 py-2" style="">
                <b-skeleton animation width="85%" height="10px" style="background-color:#fff1f6;border:1px solid #F8BBD0;margin-bottom:10px"></b-skeleton>
                <b-skeleton animation width="55%" height="10px"></b-skeleton>
                <b-skeleton animation width="70%" height="10px"></b-skeleton>
                <b-skeleton animation width="100%" height="10px"></b-skeleton>
              </div>
            </div>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            {{modal.error.title}} 
          </div>
          <!-- <div style="font-weight:500;font-size:13px;color:#616161;word-break: break-word;" v-html="modal.error.description"> -->
            <!-- {{modal.error.description}}  -->
          <!-- </div> -->
          <div class="mt-3">
            <b-button 
              class="i-button"
              style="color:white !important;background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-error');}">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="sm" id="modal-loading"  content-class="modal modal--confirmation text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div class="text-center px-3 py-4">
        <img src="@/assets/img/loader.gif" width="100" height="100" />
        <div style="font-weight:600;font-size:16px;color:#01ad85">
          Mohon tunggu sebentar 
        </div>
        <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
          Proses pengecekan Rekomendasi sedang berlangsung
        </div>
      </div>
    </b-modal>
    <b-modal  hide-header hide-footer id="modal-saving" size="sm" content-class="modal modal--error text-center p-2" centered dialog-class="d-flex justify-content-center">
      <div v-if="saveState=='SAVING'">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Proses menyimpan sedang berlangsung 
          </div>
        </div>
      </div>
      <div v-if="saveState=='SUCCESS'">
        <div class="text-center py-3">
          <img src="@/assets/img/success.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Berhasil menyimpan 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            Anda akan di <i>redirect</i> ke halaman approval dalam beberapa detik
          </div>
        </div>
      </div>
      <div v-if="saveState=='ERROR'">
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{saveError}} 
          </div>
          <div class="mt-2">
            <b-button 
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('modal-saving');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal hide-header hide-footer size="md" id="modal-approval" modal-class="modal modal--warning">
      <ValidationObserver ref="saveSubmissionObserver" v-slot="{validate}">
        <div class="modal__header border-bottom-0 ">
          <div class="modal__header__icon">
            <VueFeather type="send" size="22" stroke-width="2"></VueFeather>
          </div>
          <div class="modal__header__title">
            <div class="modal__header__title__name"> 
              Simpan Pemeriksaan 
            </div>
            <div class="modal__header__title__description" style="font-weight:500;letter-spacing:0px"> 
              Pastikan pemeriksaan sudah sesuai sebelum mengirim data ke server
            </div>
          </div>
          <div class="modal__header__close">
            <button  class="button button--action button--outlined" @click="$bvModal.hide('modal-approval')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="form text-medium" style="border-radius:4px">
            
              <b-form-group label="Status Usulan">
                <Treeselect  
                  :clearable="false" 
                  v-model="form.status" 
                  :options="options.status.filter(x=>x.id != 'REVISED')" :disable-branch-nodes="true" 
                  :loadOptions="loadOptions" class="valid"
                  
                >
                </Treeselect>
              </b-form-group>


              <ValidationProvider immediate name="Jenis penolakan"  rules="required" v-slot="{errors}" v-if="form.status == 'REJECTED'">
                <b-form-group label="Jenis penolakan">
                  <Treeselect 
                    :clearable="false"
                    placeholder="Pilih jenis alasan penolakan"
                    v-model="rejectionNote.type"
                    :class="errors[0] ? 'invalid': ( rejectionNote.type ? 'valid' : null)"
                    :options="options.rejected_status_type"
                    :loadOptions="loadOptions"
                  />
                  
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              
              </ValidationProvider>

              <ValidationProvider immediate name="Catatan"  v-if="rejectionNote.type == 'OTHER' && form.status == 'REJECTED'"  rules="required" v-slot="{errors}">
                <b-form-group label="Catatan">
                  <b-form-textarea 
                    rows="3"
                    v-model="rejectionNote.note" 
                    placeholder="Tuliskan secara jelas deskripsi ukuran" 
                    :state="errors[0] ? false: ( rejectionNote.note ? true : null)"
                  >
                  </b-form-textarea>
                  <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            
          </div>
        </div>
        <div class="modal__footer">
          <div class="d-flex ml-auto mx-1">
            <button type="button" class="button " variant="outlined" @click="$bvModal.hide('modal-approval')">Batal</button>
            <button type="button" class="button ml-2" variant="warning" @click="()=>{
              validate().then(result=>{
                if(result){
                  sendData();
                }
              })  
            }">Kirim</button>
          </div>
        </div>
      </ValidationObserver>
    </b-modal>

    
  </div>
  
</template>

<script>
import "@/assets/scss/main.scss";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueFeather from 'vue-feather';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import "vue-select/dist/vue-select.css";
import MsService from "../../../services/MsService";
import SdsService from "../../../services/SdsService";
import store from "../../../store";

import EquationEditor from "@/components/equation/EquationEditor";
import EquationViewer from "@/components/equation/EquationViewer";

export default {
  components: {
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Multiselect,
    Treeselect,
    EquationEditor,
    EquationViewer
  },
  data: () => ({
    route:null,
    baseId:null,
    updatedId:null,
    user:null,
    userRoles:[],
    isLoading:false,
    isSdsLoading:false,
    sdsSearchDebounceTimer:null,
    saveState:'SUCCESS',
    saveError:null,
    rejectionNote:{
        type:null,
        note:null,
      },
    msKeg:null,
    msInd:null,
    sdsIndicator:null,
    sds:null,
    showSdsRedirectNotif:null,
    formExt:{
      getRecommendation:false,
      produsenData:null,
      wilayah:null,
      
    },
    form:{
      ms_keg_id: null,
      submission_period: null,
      data: null,
      reviews: [],
      changes: [],
      status: "DRAFT",
      rejection_note: null,
      submitter: null,
      produsen_data: null,
      walidata_pusat: null,
      version: 'v2'
    },
    data: {
      nama: null,
      definisi:null,
      konsep: [null],
      interpretasi: null,
      metode_perhitungan: null,
      rumus: null,
      ukuran: null,
      satuan: null,
      variabel_disaggregasi: [
        {
          nama: null,
          sumber:'input-manual'
        }
      ],
      apakah_indikator_komposit: null,
      indikator_pembangun: [
        {
          nama: null,
          sumber_publikasi: [
            null
          ],
        }
      ],
      variabel_pembangun: [
        {
          nama: null,
          kegiatan_penghasil: [
            null
          ]
        }
      ],
      level_estimasi: null,
      apakah_indikator_bisa_diakses_umum: true,
      id_sds: null
    },
    review:{
      field:null,
      note:null,
    },
    isReviewOpen: true,
    isReviewCardOpen: true,
    isHistoryStatusCardOpen: true,
    options:{
      rejected_status_type :[
          {id:'IMPROPERLY_REQUEST', label:'Laporan Metadata tidak layak'},
          {id:'REQUESTED_BY_USER', label:'Diminta oleh pelapor'},
          {id:'OTHER', label:'Lainnya'},
        ],
      value_domain_type:[
          { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
          { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
        ],
      status:[
        { id: "DRAFT", label: "Draft" },
        { id: "SUBMITTED", label: "Submit" },
        { id: "UNDER_REVIEW", label: "Sedang Diperiksa" },
        { id: "REVISED", label: "Sudah Diperbaiki" },
        { id: "CORRECTION_REQUIRED", label: "Perlu Perbaikan" },
        { id: "REJECTED", label: "Ditolak" },
        { id: "APPROVED", label: "Disetujui" },
        // { id: "PUBLISHED", label: "Publis" }
      ],
      sdsStatus:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
      ya_tidak: [
        {id:true , label:'Ya', code:1},
        {id:false , label:'Tidak', code:2},
      ],
      sds:[],
      presentation_level:[
        { value: { id: 148, name: 'Nasional', description: null}, text: 'Nasional'},
        { value: { id: 149, name: 'Provinsi', description: null}, text: 'Provinsi'},
        { value: { id: 150, name: 'Kabupaten/Kota', description: null}, text: 'Kabupaten/Kota'},
        { value: { id: 151, name: 'Kecamatan', description: null}, text: 'Kecamatan'},
        { value: { id: 152, name: 'Kelurahan/Desa', description: null}, text: 'Kelurahan/Desa'}
      ],
    },
    modal:{
      error:{
        title:null,
        description:null,
      }
    }
  }),
  watch:{
  },
  computed:{
    isReviewVisible() {
      if (!this.isReviewOpen) return false;
      return (
        this.route === 'UpdateMsInd' ||
        this.route === 'ApproveMsInd' ||
        this.form.status === 'CORRECTION_REQUIRED' ||
        (this.form.reviews && this.form.reviews.length > 0) ||
        (this.reviewHistories && this.reviewHistories.length > 0) ||
        (this.msIndHistories && this.msIndHistories.length > 0)
      );
    },
    now(){
      return moment().format('YYYY-MM-DD HH:mm:ss.SSS')
    },
    reviewHistories(){
      let msInd = this.msInd;
      let showedReviews = [];
      if(msInd){
        let allReview = msInd.ms_ind_histories.filter(x=> !x.active && x.reviews && x.reviews.length>0).map(x=>x.reviews).flat();
        let currentReviewNotes = msInd.reviews ? msInd.reviews.map(x=>x.note) : [];

        
        allReview.forEach(x=>{
          if(!currentReviewNotes.includes(x.note)){
            showedReviews.push(x);
          }
        })
      }
      return showedReviews;
    },
    msIndHistories(){
      const msInd = this.msInd;
      if(!msInd || !Array.isArray(msInd.ms_ind_histories)){
        return [];
      }
      // Sort dari yang terbaru ke yang terlama
      return [...msInd.ms_ind_histories].sort((a, b) => {
        const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
        const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
        return tb - ta;
      });
    },
    kegiatanTitle() {
      if (!this.msKeg) return '';
      let dataObj = this.msKeg.data;
      if (typeof dataObj === 'string') {
        try { dataObj = JSON.parse(dataObj); } catch (e) { dataObj = {}; }
      } else if (!dataObj) {
        dataObj = {};
      }
      return dataObj.judul_kegiatan || dataObj.judulKegiatan || this.msKeg.judul_kegiatan || this.msKeg.judulKegiatan || this.msKeg.judul || '';
    },
    kegiatanVariables() {
      if (!this.msKeg || !this.msKeg.ms_var || !Array.isArray(this.msKeg.ms_var)) {
        return [];
      }
      return this.msKeg.ms_var
        .map((x, idx) => {
          let varData = x.data;
          if (typeof varData === 'string') {
            try { varData = JSON.parse(varData); } catch (e) { varData = {}; }
          } else if (!varData) {
            varData = {};
          }
          const nama = varData.nama || varData.nama_variabel || varData.name || x.nama || x.nama_variabel || '';
          const alias = varData.alias || x.alias || '';
          return {
            id: x.id || idx,
            nama: typeof nama === 'string' ? nama.trim() : String(nama),
            alias: typeof alias === 'string' ? alias.trim() : String(alias)
          };
        })
        .filter(x => x.nama && x.nama.length > 0);
    },
    kegiatanIndicators() {
      if (!this.msKeg || !this.msKeg.ms_ind || !Array.isArray(this.msKeg.ms_ind)) {
        return [];
      }
      return this.msKeg.ms_ind
        .filter(x => {
          const currentId = this.updatedId || (this.msInd && this.msInd.id);
          if (currentId && String(x.id) === String(currentId)) {
            return false;
          }
          if (this.route === 'UpdateMsInd' && this.data && this.data.nama && (x.nama === this.data.nama || (x.data && x.data.nama === this.data.nama))) {
            return false;
          }
          return true;
        })
        .map((x, idx) => {
          let indData = x.data;
          if (typeof indData === 'string') {
            try { indData = JSON.parse(indData); } catch (e) { indData = {}; }
          } else if (!indData) {
            indData = {};
          }
          const nama = indData.nama || indData.nama_indikator || indData.name || x.nama || x.nama_indikator || '';
          return {
            id: x.id || idx,
            nama: typeof nama === 'string' ? nama.trim() : String(nama)
          };
        })
        .filter(x => x.nama && x.nama.length > 0);
    },


  },
  async mounted() {
    this.route = this.$route.name;
    this.getUserInfo(store.getters["auth/user"]);
    if(this.route == "AddMsInd"){
      this.getDetailMsKeg(this.$route.params.id);
      this.fetchApprovedSdsIndicators('');
    }
    if (this.route == "ViewMsInd" || this.route == 'UpdateMsInd' || this.route == 'ApproveMsInd') {
      let id = parseInt(this.$route.params.id);
       this.updatedId = id;

      this.isLoading = true;
      await this.getDetailMsInd(id);
      this.isLoading = false;
    }
  },
  
  methods: {
    onKompositInput(val) {
      if (val === true) {
        this.data.variabel_pembangun = [];
        this.data.indikator_pembangun = [
          {
            nama: null,
            sumber_publikasi: [null]
          }
        ];
      } else if (val === false) {
        this.data.indikator_pembangun = [];
        this.data.variabel_pembangun = [
          {
            nama: null,
            kegiatan_penghasil: [null]
          }
        ];
      }
    },
    onSelectIndikatorPembangun(item, indicator) {
      this.$set(item, 'nama', indicator.nama);
      const kegTitle = this.kegiatanTitle;
      if (kegTitle) {
        this.$set(item, 'sumber_publikasi', [kegTitle]);
      }
    },
    onIndikatorPembangunChange(item) {
      if (!item.nama) return;
      const matched = this.kegiatanIndicators.find(ind => ind.nama.toLowerCase() === item.nama.trim().toLowerCase());
      if (matched) {
        const kegTitle = this.kegiatanTitle;
        if (kegTitle) {
          this.$set(item, 'sumber_publikasi', [kegTitle]);
        }
      }
    },
    onSelectVariabelPembangun(item, variable) {
      this.$set(item, 'nama', variable.nama);
      const kegTitle = this.kegiatanTitle;
      if (kegTitle) {
        if (!item.kegiatan_penghasil || item.kegiatan_penghasil.length === 0 || !item.kegiatan_penghasil[0]) {
          this.$set(item, 'kegiatan_penghasil', [kegTitle]);
        }
      }
    },
    onVariabelPembangunChange(item) {
      if (!item.nama) return;
      const matched = this.kegiatanVariables.find(v => v.nama.toLowerCase() === item.nama.trim().toLowerCase());
      if (matched) {
        const kegTitle = this.kegiatanTitle;
        if (kegTitle && (!item.kegiatan_penghasil || item.kegiatan_penghasil.length === 0 || !item.kegiatan_penghasil[0])) {
          this.$set(item, 'kegiatan_penghasil', [kegTitle]);
        }
      }
    },
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
      this.form.submitter = this.user;
    },
    getSdsList(searchQuery){
      if (this.sdsSearchDebounceTimer) {
        clearTimeout(this.sdsSearchDebounceTimer);
      }
      this.sdsSearchDebounceTimer = setTimeout(() => {
        this.fetchApprovedSdsIndicators(searchQuery);
      }, 300);
    },
    async onSdsOpen(){
      if (!this.options.sds || this.options.sds.length === 0) {
        await this.fetchApprovedSdsIndicators(this.data.nama || '');
      }
    },
    async fetchApprovedSdsIndicators(searchQuery){
      const queryText = (searchQuery || '').trim();
      this.isSdsLoading = true;
      const encoded = encodeURIComponent(queryText);
      const queryPusat = 'name=' + encoded + '&sdsType=INDICATOR&status=APPROVED_PUSAT&page=0&size=30';
      const queryKabkota = 'name=' + encoded + '&sdsType=INDICATOR&status=APPROVED_KABKOTA&page=0&size=10';

      try {
        const [resPusat, resKabkota] = await Promise.all([
          SdsService.getSdsItemListByQuery(queryPusat).catch(() => ({ data: { content: [] } })),
          SdsService.getSdsItemListByQuery(queryKabkota).catch(() => ({ data: { content: [] } }))
        ]);

        const itemsPusat = (resPusat && resPusat.data && resPusat.data.content) || [];
        const itemsKabkota = (resKabkota && resKabkota.data && resKabkota.data.content) || [];

        const map = new Map();
        [...itemsPusat, ...itemsKabkota].forEach(item => {
          if (item && item.id && !map.has(item.id)) {
            const st = (item.status || '').toUpperCase();
            if (st.includes('APPROVED') || st.includes('PUBLISH') || st === 'DITERIMA') {
              map.set(item.id, item);
            }
          }
        });

        this.options.sds = Array.from(map.values());
      } catch (err) {
        console.error('Error fetching approved SDS indicators:', err);
      } finally {
        this.isSdsLoading = false;
      }
    },
    async getDetailMsKeg(id){
      await MsService.getMsKegById(id).then(
        response => {
          this.msKeg = response.data.result[0];
          this.form.ms_keg_id = parseInt(id);
          this.form.submission_period = this.msKeg.submission_period;
          this.form.produsen_data = this.msKeg.produsen_data;
          this.form.produsen_data = this.msKeg.produsen_data;
          this.form.submitter= this.user;
          this.form.produsen_data={
            id: this.msKeg.produsen_data_id,
            name: this.msKeg.produsen_data_name,
            province_code: this.msKeg.produsen_data_province_code,
            city_code: this.msKeg.produsen_data_city_code
          };
          this.form.walidata_pusat= {
            id: this.msKeg.walidata_pusat_id,
            name: this.msKeg.walidata_pusat_name
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    async getDetailMsInd(id){
      await MsService.getMsIndById(id).then(
        async response => {
          this.msInd = response.data.result[0];
          this.data = this.msInd.data;
          this.form.reviews = this.msInd.reviews ? this.msInd.reviews : [];
          this.form.status = this.msInd.status;
          const kegId = this.msInd.ms_keg_id || this.msInd.id_ms_keg;
          this.form.ms_keg_id = kegId;
          if (kegId && (!this.msKeg || !this.msKeg.ms_var || !this.msKeg.ms_ind)) {
            await this.getDetailMsKeg(kegId);
          }
          this.form.submission_period = this.msInd.submission_period;
          this.form.produsen_data = this.msInd.produsen_data;
          this.form.submitter= this.user;
          this.form.produsen_data={
            id: this.msInd.produsen_data_id,
            name: this.msInd.produsen_data_name,
            province_code: this.msInd.produsen_data_province_code,
            city_code: this.msInd.produsen_data_city_code
          };
          this.form.walidata_pusat= {
            id: this.msInd.walidata_pusat_id,
            name: this.msInd.walidata_pusat_name
          }
          if(this.route == 'ApproveMsInd'){
            this.form.status = this.msInd.status == 'SUBMITTED' || this.msInd.status == 'REVISED' ? 'UNDER_REVIEW' : this.msInd.status;
          }else{
            this.form.status = this.msInd.status;
          }
          
          let indikator = this.msInd.data;
          if(this.msInd.version == 'v1'){
            this.data= {
              nama: indikator.nama,
              konsep: indikator.konsep ? [indikator.konsep] : [null],
              definisi: indikator.definisi,
              interpretasi: indikator.interpretasi,
              metode_perhitungan: indikator.metodeAtauRumusPerhitungan,
              rumus: null,
              ukuran: indikator.ukuran,
              satuan: indikator.satuan,
              variabel_disaggregasi: indikator.variabelDisaggregasi && indikator.variabelDisaggregasi.length>0 ? indikator.variabelDisaggregasi : [{nama: null, sumber:'input-manual'}],
              apakah_indikator_komposit: indikator.apakahIndikatorKomposit,
              indikator_pembangun: indikator.indikatorPembangun.map(x=>({
                  nama: x.nama,
                  sumber_publikasi: x.ketersediaanPublikasi.map(x=>x.nama)
                })
              ),
              variabel_pembangun: indikator.variabelPembangun.map(x=>({
                  nama: x.nama,
                  kegiatan_penghasil: x.kegiatanPenghasil
                })
              ),
              level_estimasi: indikator.levelEstimasi,
              apakah_indikator_bisa_diakses_umum: indikator.apakahIndikatorBisaDiaksesUmum,
              id_sds: null
            };
          }
          //change structure was caused disagregation can be subset of sds
          this.data.variabel_disaggregasi = this.data.variabel_disaggregasi.map(x=>{
            if(typeof x == 'string' || x == null){
              return this.data.id_sds ? {nama: x, sumber:'sds'} : {nama: x, sumber:'input-manual'}
            }else{
              return x
            }
          })
          this.sds = {
            id: indikator.nama,
            name: indikator.nama,
          }
        },
        error => {
          console.error(error);
        }
      );
    },
    async validateAll(){
      return await this.$refs.blok1Observer.validate();
    },
    async save(saveType) {
      let valid = await this.validateAll();
      this.form.data = this.data;
      if(saveType == 'DRAFT'){
        let minValid = true;
        if(this.form.data.nama == null){
          minValid = false;
          this.modal.error.description = 'Untuk dapat menyimpan dalam bentuk DRAFT, <span class="text-primary">Nama Indikator</span> tidak boleh kosong';
        }
        if(minValid){
          this.sendData()
        }else{
          this.modal.error.title = 'Isian Error';
          this.$bvModal.show('modal-error');
        }
      }else{
        if(valid){
          this.form.status=this.form.status == 'DRAFT' ? 'SUBMITTED' : 'REVISED'; 
          this.sendData()
        }else{
          this.modal.error.title = 'Isian Error';
          this.modal.error.description = 'Untuk dapat melakukan submit, pastikan tidak ada lagi isian yang error';
          this.$bvModal.show('modal-error');
        }
      }
    },
    async sendData(){
      this.$bvModal.show('modal-saving');
      this.saveState = 'SAVING';
      this.form.data = this.data;
      if(this.route == "UpdateMsInd" || this.route == "ApproveMsInd"){
        MsService.updateMsInd(this.form,this.updatedId).then(
          (result) => {
            let response = result.data.result[0];
            if(response.status == 403 || response.status == 500){
              if(response.status == 403){
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk mengupdate item';
              }
              else{
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            }else{
              this.saveState = 'SUCCESS';

              if(this.route == "UpdateMsInd" ){
                this.delay(2000).then(() => this.$router.push('/metadata/view-kegiatan/'+this.form.ms_keg_id));
              }else{
                this.delay(2000).then(() => this.$router.push('/metadata/pemeriksaan/kegiatan/'+this.form.ms_keg_id));
              }
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      }else{
        MsService.saveNewMsInd(this.form).then(
          (result) => {
            let response = result.data.result[0];
            if(response.status == 403 || response.status == 500){
              if(response.status == 403){
                this.modal.error.title = 'Forbidden';
                this.modal.error.description = 'Anda tidak mempunyai akses untuk menambahkan item';
              }
              else{
                this.modal.error.title = response.title;
                this.modal.error.description = response.detail;
              }
              this.$bvModal.hide('modal-saving');
              this.$bvModal.show('modal-error');
            }else{
              this.saveState = 'SUCCESS';
              this.delay(2000).then(() => this.$router.push('/metadata/view-kegiatan/'+this.form.ms_keg_id));
            }
          },
          (error) => {
            this.saveState = 'ERROR';
            this.saveError = error.response;
          }
        );
      }
      
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    statusFormatterStyle(status){
      return status ? status.toLowerCase().replace('_','-') : 'draft';
    },
    statusFormatter(status){
      let stat = this.options.status.find(x=>x.id == status)
      return stat ? stat.label : 'Draft';
    },
    sdsStatusFormatter(status){
      let stat = this.options.sdsStatus.find(x=>x.value == status)
      return stat ? stat.label : 'Draft';
    },
    changeQuesModeValue(att){
      this.ques[att] = this.options[att].find(x=>x.id==this.data[att]).code
    },
    changeEntriModeValue(att){
      let value = this.options[att].find(x=>x.code==this.ques[att]);
      if(value){
        this.data[att] = value.id;
      }
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    scrollToUpperMost: function() {
      setTimeout(function() {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }, 100);
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    async useIndicatorSds(indicator){
      this.showSdsRedirectNotif = false;
      if(indicator){
        await SdsService.getSdsItem(indicator.id).then(
           (result)=>{
            let x =  {...result.data.result[0]};
            this.sdsIndicator = this.updateIndicatorStructure(x.data.indicator, x.submission_type);
            this.data.nama= this.sdsIndicator.name;
            this.data.konsep= this.sdsIndicator.concepts.length>0 ? this.sdsIndicator.concepts.map(x=>x.name) : [null];
            this.data.definisi= this.sdsIndicator.definition;
            this.data.interpretasi= this.sdsIndicator.interpretation;
            this.data.metode_perhitungan= this.sdsIndicator.calculation_mechanism;
            // this.data.rumus= null;
            this.data.ukuran= this.sdsIndicator.measurement ? this.sdsIndicator.measurement.name : null;
            this.data.satuan= this.sdsIndicator.measurement_unit ? this.sdsIndicator.measurement_unit.name : null;
            this.data.variabel_disaggregasi= (this.sdsIndicator.disaggregations && this.sdsIndicator.disaggregations.length > 0) ? this.sdsIndicator.disaggregations.map(x=>({nama:x.name, sumber:'sds'})) : [{nama: null, sumber:'input-manual'}];
            
            this.data.id_sds= x.id;
            //  this.$nextTick();
            this.$nextTick(function () {
                this.data.rumus= this.sdsIndicator.formula;
            })
            this.$forceUpdate();

          },
          (error)=>{
            console.log(error);
          }
        );
      }else{
        this.data.nama= null;
        this.data.konsep= [null];
        this.data.definisi= null;
        this.data.interpretasi= null;
        this.data.metode_perhitungan= null;
        this.data.rumus= null;
        this.data.ukuran= null;
        this.data.satuan= null;
        this.data.variabel_disaggregasi= [{nama: null, sumber:'input-manual'}];
        this.data.id_sds= null;
      }
      
    },
    inputIndicatorManual(indicator){
      this.showSdsRedirectNotif = true;
      this.sds = {
        id : indicator,
        name : indicator
      }
      this.data.nama = indicator;
      this.data.konsep= [null];
      this.data.definisi= null;
      this.data.interpretasi= null;
      this.data.metode_perhitungan= null;
      this.data.rumus= null;
      this.data.ukuran= null;
      this.data.satuan= null;
      this.data.variabel_disaggregasi= [{
          nama: null,
          sumber:'input-manual'
        }];
      this.data.id_sds= null;
    },
    updateIndicatorStructure(indicator){
      // let submissionType = sdsItem.submission_type;
      // let variable = sdsItem.data.variable;
      // console.log(variable)
      let newIndicator = {
        name: indicator.name,
        definition: indicator.definition,
        concepts: indicator.concepts, //update with actual state,
        measurement: indicator.measurement, //change format json
        measurement_unit: indicator.measurement_unit, //change format json,
        subject_field: indicator.subject_field, //change format json,
        benefit: indicator.benefit,
        interpretation: indicator.interpretation,
        presentation_levels: indicator.presentation_levels, //change format json,
        calculation_mechanism: indicator.calculation_mechanism,
        formula: indicator.formula,
        formula_structures: indicator.formula_structures,
        disaggregations: indicator.disaggregations, //update with actual state,
        references: indicator.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_indicator: null,
      }
      //change format json for measurement 
      if(newIndicator.measurement){
        if(newIndicator.measurement.id == null){
          let newMeasurement = {
            id:null,
            name:newIndicator.measurement.name,
            description:null,
          };
          newIndicator.measurement = newMeasurement;
        }
      }
      //change format json for measurement unit
      if(newIndicator.measurement_unit){
        if(newIndicator.measurement_unit.id == null){
          let newMeasurementUnit = {
            id: null,
            name: newIndicator.measurement_unit.name,
            symbol: null
          }
          newIndicator.measurement_unit = newMeasurementUnit;
        }
      }

      if(newIndicator.presentation_levels != null & newIndicator.presentation_levels.length>0){
        //there is posibilty that there is a duplicate item, so we will remove it
        let unique = new Set();
        newIndicator.presentation_levels = newIndicator.presentation_levels.filter(obj => {
          let isPresent = unique.has(obj.id);
          unique.add(obj.id);
          return !isPresent;
        });
        
        newIndicator.presentation_levels = newIndicator.presentation_levels.map(item => {
          let z = this.options.presentation_level.map(x=> x.value).find(x => x.id == item.id);
          return z;
        });
      }
      return newIndicator;
    },
    alert(message){
      console.log(message)
    }
    
  },
 
};
</script>

<style lang="scss">
.input-custom-var {
  height: 38px !important;
  border-radius: 6px !important;
  border: 1px solid #bfbfbf !important;
  font-size: 13.5px !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    border-color: #008b7e !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 139, 126, 0.15) !important;
  }
}

.dropdown-pilih-var {
  display: inline-flex !important;
  align-items: center !important;

  .btn-pilih-var {
    height: 38px !important;
    border-radius: 6px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 14px !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #008b7e !important;
    background: #eef8f6 !important;
    border: 1.5px solid #9aece7 !important;
    white-space: nowrap !important;
    cursor: pointer !important;
    transition: transform 0.16s ease-out, background-color 0.18s ease-out, border-color 0.18s ease-out, box-shadow 0.18s ease-out !important;
    box-shadow: 0 1px 2px rgba(0, 139, 126, 0.08) !important;

    &:hover, &:focus {
      background: #008b7e !important;
      color: #ffffff !important;
      border-color: #008b7e !important;
      box-shadow: 0 3px 8px rgba(0, 139, 126, 0.25) !important;
      transform: translateY(-1px);

      .btn-var-icon, .btn-var-chevron {
        stroke: #ffffff !important;
      }
    }

    &:active {
      transform: translateY(0) scale(0.97) !important;
    }

    .btn-var-icon {
      margin-right: 6px;
      stroke: #008b7e;
      flex-shrink: 0;
      transition: stroke 0.18s ease;
    }

    .btn-var-label {
      font-weight: 600;
      letter-spacing: 0.2px;
    }

    .btn-var-chevron {
      margin-left: 6px;
      stroke: #008b7e;
      opacity: 0.85;
      flex-shrink: 0;
      transition: transform 0.2s cubic-bezier(0.23, 1, 0.32, 1), stroke 0.18s ease;
    }
  }

  &.show .btn-var-chevron {
    transform: rotate(180deg);
  }
}

.menu-pilih-var {
  border-radius: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.12), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;
  padding: 0 !important;
  overflow: hidden;
  margin-top: 5px !important;

  .dropdown-item {
    padding: 8px 14px !important;
    transition: background-color 0.15s ease;
    border-bottom: 1px solid #f8f9fa;

    &:last-child {
      border-bottom: none;
    }

    &:hover, &:focus {
      background-color: #f0fdf9 !important;
    }
  }
}
</style>
